// middleware/redirectFromMiddleware.js

export default function ({ req, from, redirect }) {
    // Az HTTP referer lekérdezése a request objektumból
    const referer = req.headers.referer || '/' // Alapértelmezett érték, ha nincs referer
    console.log('dolgok', { referer })
}
